import CompanyPropertyModel     from 'Models/directory/CompanyPropertyModel';
import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { Timestampable }        from 'helpers/traits';
import { Blamable }             from 'helpers/traits';
import DirectoryPrivateApiModel from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.staticLabel('CountryCompanyProperty')
@model.urnResource('country_company_property')
@doc.path('/country_company_properties/{?id}')
export default class CountryCompanyPropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'companyProperty': id;
		'companyProperty.reference': DirectoryCompanyPropertyReference;
		'country': id;
		'enterpriseTypeCountryCompanyProperties': id;
		'enterpriseTypeCountryCompanyProperties.enterpriseType': id;
		'enterpriseTypeCountryCompanyProperties.enterpriseType.reference': DirectoryEnterpriseTypeReference;
		'enterpriseTypeCountryCompanyProperties.required': '0' | '1';
		'isUnique': '0' | '1';
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.model(CompanyPropertyModel) declare companyProperty: CompanyPropertyModel;
	@doc.string declare country: string;
	@doc.boolean declare isUnique: boolean;
	@doc.boolean declare unique: boolean;
}